<template>
  <div :class="`parameter-router-auth-container ${isInsideDialog ? 'parameter-router-auth-container--dialog': ''} auth-container`">
    <back-btn
      dark
      :class="{ 'hidden': !authType }"
      :text="$t('auth.back')"
      @click="authType = null"
    />
    <auth-methods :params="params" :authType="authType" @changeAuthType="changeAuthType" @authenticated="verifyProfile" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'parameter-router-auth-container',
  props: {
    isInsideDialog: Boolean,
    initialAuthType: {
      type: String,
      default: 'signup'
    }
  },
  data: function() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      params: {},
      authType: this.initialAuthType === 'email' ? null : this.initialAuthType
    }
  },
  computed: mapState({ isUserSubscribed: state => state.user.isSubscribed }),
  methods: {
    changeAuthType(type, params, replace) {
      this.authType = type
      this.params = params
    },
    verifyProfile() {
      if (this.isUserSubscribed) {
        this.$router.push({ name: 'browse' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin small-screens-style {
  padding: 0 28px 40px;

  & > img {
    width: 150px;
    margin: 0 auto;
    margin-bottom: 12px;
  }

  &__headline {
    margin-top: 24px;
    margin-bottom: 32px;
    padding: 0 20px;

    & > h1 {
      margin-top: 0;
      margin-bottom: 6px;
      font-size: 18px;
    }

    & > h2 {
      margin-bottom: 0;
      font: {
        size: 16px;
        weight: normal;
      }
    }
  }
}

.parameter-router-auth-container {
  align-self: center;;
  &__separator {
    margin: 14px 0;
  }

  & > .consent-box {
    margin-bottom: 12px;
  }

  &__signup-types {
    display: flex;
    flex-direction: column;
  }

  & > span {
    font: {
      size: 14px;
      weight: normal;
    }
  }

  &--dialog {
    @include small-screens-style();
  }

  @media screen and (max-width: 576px) {
    @include small-screens-style()
  }
}
</style>

<style lang="scss">
.parameter-router-auth-container--dialog .input-container {
  max-width: unset;
}
</style>
